(function(angular){
	'use strict';

	angular
		.module('additionalInvestmentLandingModule')
		.factory('AdditionalInvestmentFactory', [
			'$filter',
			'Big',
			'DEFAULT_ORDER_AMOUNT_OPTIONS',
			'MINIMUM_RIA_ORDER_AMOUNT',
			'OFUND_ORDER_AMOUNT_OPTIONS',
			additionalInvestmentFactoryFunction
		]);

	function additionalInvestmentFactoryFunction(
		$filter,
		Big,
		DEFAULT_ORDER_AMOUNT_OPTIONS,
		MINIMUM_RIA_ORDER_AMOUNT,
		OFUND_ORDER_AMOUNT_OPTIONS
	) {
		var factory = {
			getAmountOptionsAndDefault: getAmountOptionsAndDefault
		};

		function getAmountOptionsAndDefault(amountFromUrlParam, fixedAmount, isRiaOrder, nextServiceLevel, reitType) {
			var result = {};

			result.amountOptions = getAmountOptions(isRiaOrder, nextServiceLevel, reitType);
			result.amount = getAmount(amountFromUrlParam, fixedAmount,reitType, result.amountOptions);

			result.amountOptions = $filter('orderBy')(result.amountOptions, 'sortIndex');

			return result;
		}

		function getAmount(amountFromUrlParam, fixedAmount, reitType, amountOptions) {
			var amount;

			if(angular.isDefined(amountFromUrlParam)) {
				if(amountFromUrlParam === 'minToUpgrade') {
					amount = $filter('filter')(amountOptions, {'isMinToUpgrade': true}, true)[0];
				} else {
					amount = {
						value: parseInt(amountFromUrlParam),
						label: $filter('currency')(amountFromUrlParam, '$', 0),
						sortIndex:  parseInt(amountFromUrlParam)
					};
				}
			} else if(angular.isDefined(fixedAmount)) {
				var fixedAmountString = Big(fixedAmount).toFixed(2);
				amount = {
					value: fixedAmountString,
					label: $filter('currency')(fixedAmountString, '$', 0)
				};
			} else if(reitType === 'OPPORTUNITY_FUND') {
				amount = amountOptions[1];
			} else if(reitType === 'EREIT' || reitType === 'EFUND') {
				amount = amountOptions[1];
			} else {
				amount = amountOptions[0];
			}

			return amount;
		}

		function getAmountOptions(isRiaOrder, nextServiceLevel, reitType) {
			var amountOptions;

			if(reitType === 'OPPORTUNITY_FUND') {
				amountOptions = angular.copy(OFUND_ORDER_AMOUNT_OPTIONS);
			} else {
				amountOptions = angular.copy(DEFAULT_ORDER_AMOUNT_OPTIONS);

				if(isRiaOrder && angular.isDefined(nextServiceLevel) && nextServiceLevel.amountNeededToUpgrade > 0) {
					amountOptions = $filter('filter')(amountOptions, function(amountOption) {
						return amountOption.value !== nextServiceLevel.amountNeededToUpgrade;
					});

					setUpgradeAmountOption(amountOptions, nextServiceLevel.amountNeededToUpgrade, Number(nextServiceLevel.principalInvestedToDate), nextServiceLevel.label, Number(nextServiceLevel.upgradeCommunicationThreshold));
				}
			}

			amountOptions.unshift({label: "Choose an amount\u2026", sortIndex: 0});
			amountOptions.push({value: "other", label: "Other amount", sortIndex: 100000000});

			return amountOptions;
		}

		function setUpgradeAmountOption(orderAmountOptions, amountNeededToUpgrade, principalInvestedToDate, nextServiceLevelName, upgradeCommunicationThreshold) {
			var amountNeededToUpgradeOption;

			if(amountNeededToUpgrade <= MINIMUM_RIA_ORDER_AMOUNT) {
				amountNeededToUpgradeOption = {
					value: MINIMUM_RIA_ORDER_AMOUNT
				};
			} else if (principalInvestedToDate >= upgradeCommunicationThreshold) {
				amountNeededToUpgradeOption = {
					value: amountNeededToUpgrade
				};

			}

			if(angular.isDefined(amountNeededToUpgradeOption)) {
				orderAmountOptions.push(amountNeededToUpgradeOption);
				amountNeededToUpgradeOption.label = $filter('currency')(amountNeededToUpgradeOption.value, '$', 0) + ' - unlock ' + nextServiceLevelName + ' account level!';
				amountNeededToUpgradeOption.isMinToUpgrade = true;
				amountNeededToUpgradeOption.sortIndex = amountNeededToUpgrade;
			}

			return orderAmountOptions;
		}

		return factory;
	}
})(window.angular);